import React from 'react';

import SingleValueDropdownFilterForm from 'search/filters/base/SingleValueDropdownFilterForm';
import ResiduesFilterForm, {ResiduesFilterFormProps} from 'search/filters/ResiduesFilterForm';
import {Operator, OPERATOR_TO_TEXT} from 'search/SearchConstants';

export default function AminoAcidsFilterForm(props: ResiduesFilterFormProps): JSX.Element {
  if ([Operator.INCLUDES_TEXT, Operator.IS].includes(props.filter.operator)) {
    return <ResiduesFilterForm {...props} placeholder="AA String" />;
  } else {
    return (
      <SingleValueDropdownFilterForm
        {...props}
        filterStyle={props.filterStyle}
        optionDatas={props.operators.map((op) => ({
          name: OPERATOR_TO_TEXT[op],
          value: op,
        }))}
        value={Operator.IS_NOT_EMPTY}
        onChangeValue={(operator: string) => {
          props.onChangeFilter({
            ...props.filter,
            operator: operator as Operator,
          });
        }}
      />
    );
  }
}
